import React from "react"

// Botón para compartir el resultado de una tirada (loop viral fanpage/amigos).
// En mobile usa la Web Share API (menú nativo: WhatsApp, Instagram Stories, etc.);
// si no está disponible, cae a un intent de WhatsApp. Comparte las cartas + el
// link del juego, para que quien lo reciba entre al sitio (preview con OG image).
const GAME_LABELS = {
  "baralho-cigano": "no Baralho Cigano",
  "tarot-da-sorte": "no Tarot da Sorte",
  "tarot-do-amor": "no Tarot do Amor",
  "jogo-de-tarot": "no Tarot",
  runas: "nas Runas",
  cristais: "no Oráculo dos Cristais",
  "tarot-sim-ou-nao": "no Tarot Sim ou Não",
  "mesa-real": "na Mesa Real",
}

const trackShare = game => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "share_reading", { game: game || "oraculo" })
  }
}

const ShareReading = ({ game, cards }) => {
  const handleShare = () => {
    trackShare(game)
    const url =
      typeof window !== "undefined"
        ? window.location.origin + window.location.pathname
        : "https://www.estrelaguia.com.br/"
    const lista = (cards || []).filter(Boolean).join(", ")
    const onde = GAME_LABELS[game] || "no EstrelaGuia"
    const text = lista
      ? `Tirei estas cartas ${onde} 🌙: ${lista}. Descubra a sua tirada:`
      : `Fiz minha tirada ${onde} 🌙 no EstrelaGuia. Descubra a sua:`

    if (typeof navigator !== "undefined" && navigator.share) {
      navigator
        .share({ title: "Minha tirada no EstrelaGuia", text, url })
        .catch(() => {})
    } else if (typeof window !== "undefined") {
      window.open(
        `https://wa.me/?text=${encodeURIComponent(text + " " + url)}`,
        "_blank",
        "noopener"
      )
    }
  }

  return (
    <button type="button" className="share-reading" onClick={handleShare}>
      <span aria-hidden="true">📲</span> Compartilhar minha tirada
    </button>
  )
}

export default ShareReading
